// Routes ///////////////////////////////////////////////////////////////
export const PackagesRoute = (): string => '/wallet/packages/';
export const BasketRoute = (): string => '/wallet/basket';

// API //////////////////////////////////////////////////////////////////

export const ProductsUrl = (): string => '/api/v1/packages/?tag=pwa';

export const BasketUrl = (couponCode?: string): string =>
  couponCode
    ? `/api/v1/wallet/basket/?coupon_code=${couponCode}`
    : '/api/v1/wallet/basket/';

export const CheckoutUrl = (couponCode?: string): string =>
  couponCode
    ? `/api/v1/wallet/checkout/?coupon_code=${couponCode}`
    : `/api/v1/wallet/checkout/`;

export const TransactionUrl = (id: string | string[]): string =>
  `/api/v1/wallet/transaction_history/${id}/`;
